/* tslint:disable */
/* eslint-disable */
/**
 * Guarantees API
 * Référentiel des garanties, rattachées aux branches
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GarantieReferentielDto } from './GarantieReferentielDto';
import {
    GarantieReferentielDtoFromJSON,
    GarantieReferentielDtoFromJSONTyped,
    GarantieReferentielDtoToJSON,
    GarantieReferentielDtoToJSONTyped,
} from './GarantieReferentielDto';

/**
 * Résultat paginé de la recherche de garanties.
 * @export
 * @interface SearchGarantiesReferentielResponse
 */
export interface SearchGarantiesReferentielResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchGarantiesReferentielResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<GarantieReferentielDto>}
     * @memberof SearchGarantiesReferentielResponse
     */
    items?: Array<GarantieReferentielDto>;
}

/**
 * Check if a given object implements the SearchGarantiesReferentielResponse interface.
 */
export function instanceOfSearchGarantiesReferentielResponse(value: object): value is SearchGarantiesReferentielResponse {
    return true;
}

export function SearchGarantiesReferentielResponseFromJSON(json: any): SearchGarantiesReferentielResponse {
    return SearchGarantiesReferentielResponseFromJSONTyped(json, false);
}

export function SearchGarantiesReferentielResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGarantiesReferentielResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GarantieReferentielDtoFromJSON)),
    };
}

export function SearchGarantiesReferentielResponseToJSON(json: any): SearchGarantiesReferentielResponse {
    return SearchGarantiesReferentielResponseToJSONTyped(json, false);
}

export function SearchGarantiesReferentielResponseToJSONTyped(value?: SearchGarantiesReferentielResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GarantieReferentielDtoToJSON)),
    };
}

